import { generatePath } from 'react-router-dom';
import { axiosInstance } from "../common";

const ENDPOINT = `/vendor/auth`;
const ENDPOINTACTION = `/vendor/auth/:action`


export const emailLogin = (headers, payload) => axiosInstance.post(ENDPOINT, payload, { headers });

export const resetPassword = (email) => axiosInstance.post(generatePath(ENDPOINTACTION, {
    action: 'reset-password'
}), {
    email
}).then(({ message }) => message);

export const changePassword = (password, token) => axiosInstance.post(generatePath(ENDPOINTACTION, {
    action: 'change-password'
}), {
    token,
    change_password: password
}).then(({ message }) => message);

export const logout = () => axiosInstance.post(generatePath(ENDPOINTACTION, {
    action: 'logout'
})).then(({ message }) => message)